<template>
  <div class="row d-none d-lg-flex">
    <div cols="6" class="col-6">
      <div class="d-flex flex-column justify-content-center h-100">
        <span>
          {{
            $label('page.shop.totalBooks', {
              books: numberOfBooks,
            })
          }}
        </span>
      </div>
    </div>
    <ShopSorting
      :selected-value="selectedValue"
      :on-sort-change="onSortChange"
    />
  </div>
</template>

<script>
import ShopSorting from './ShopSorting'

export default {
  components: {
    ShopSorting,
  },
  props: {
    numberOfBooks: {
      type: Number,
      default: 0,
    },
    selectedValue: {
      type: String,
      default: '',
    },
    onSortChange: {
      type: Function,
      required: true,
    },
  },
}
</script>
